<div class="aeg-admin-search-actor">
    <form @submit.prevent="search" class="vl-form aeg-u-bg-alt aeg-u-box-padding">
        <div class="aeg-u-bg-white aeg-u-box-padding">
            <vl-form-grid mod-stacked>
                <vl-column width="12">
                    <label for="identifier">Identificator</label>
                    <vl-input-field id="identifier" name="identifier" v-model="identifier" autocomplete="off" mod-block/>
                </vl-column>
                <vl-column width="6">
                    <label for="name">Naam</label>
                    <vl-input-field id="name" name="name" v-model="name" autocomplete="off" mod-block/>
                </vl-column>
                <vl-column width="6">
                    <label for="service">Service</label>
                    <vl-select id="service" name="service" mod-no-placeholder mod-block v-model="selectedService">
                        <option v-for="opt in serviceOptions" :key="String(opt.value)" :value="opt.value">
                            {{ opt.label }}
                        </option>
                    </vl-select>
                </vl-column>
            </vl-form-grid>
        </div>
    </form>
</div>

